import { EmailTemplateSaaSFormat, EmailTemplateSaaSFormatApiType, UpdateEmailTemplateApiType } from '../../../../Services/EmailTemplateServicesTypes';
import { Template, TemplateProperty } from '../../../WysiwygEditor/Types/BespokeTypes';
import { EmailTemplateObject } from './EmailTemplateTypes';
import { CreateEmailTemplateApiType, TemplatePropertiesValue, RecommendationConfigurationApiType } from '../../../../Services/EmailTemplateServicesTypes';

function buildTemplateFrom(saasFormat: EmailTemplateSaaSFormatApiType): Template {
	return {
		Key: saasFormat.id,
		Description: saasFormat.description,
		ThumbnailUrl: saasFormat.thumbnailUrl,
		Name: saasFormat.name,
		Properties: saasFormat.properties as TemplateProperty[],
		TemplateDescriptorDesktop: { Css: '' },
		TemplateDescriptorMobile: { Css: '' },
		TemplateName: saasFormat.templateName,
		WysiwygDesktop: { Template: saasFormat.wysiwyg.template },
		WysiwygMobile: { Template: saasFormat.wysiwyg.template }
	};
}
export function convertSaaSFormatFromApiType(saasFormat: EmailTemplateSaaSFormatApiType): EmailTemplateSaaSFormat {
	return {
		template: buildTemplateFrom(saasFormat),
		params: saasFormat.params
	};
}

export function convertSaaSFormatsFromApiType(saasFormats: EmailTemplateSaaSFormatApiType[]): EmailTemplateSaaSFormat[] {
	return saasFormats.map(convertSaaSFormatFromApiType);
}
export const convertRecommendationCfg = (recoCfg: TemplateProperty[]) => {
	function isJsonString(str: any) {
		try {
			JSON.parse(str);
		} catch (e) {
			console.error('=>(convertRecommendationCfg) JSON.parse error', e);
			return false;
		}
		return true;
	}

	const hasReco = recoCfg.find(editor => editor.Editor.Type === 'ProductRecommendations');
	if (hasReco) {
		const recoValue = hasReco.Value;
		return isJsonString(recoValue) ? recoValue : JSON.stringify(recoValue);
	} else {
		return null;
	}
};

export function convertEmailTemplateForSaving(emailTemplate: EmailTemplateObject): CreateEmailTemplateApiType {
	const reco = convertRecommendationCfg(emailTemplate.Properties);
	const cleanedReco = reco ? reco.trim().replace(/[\u200B-\u200D\uFEFF\s]/g, '') : '';
	const isRecoValid = typeof cleanedReco === 'string' && cleanedReco.length > 0 && cleanedReco !== '""';

	let elementsReco: any = null;
	try {
		elementsReco = isRecoValid ? JSON.parse(cleanedReco) : null;
	} catch (e) {
		console.error('=>(TypeAdapters.tsx:57) JSON.parse error', e);
	}

	const recommendationConfig: RecommendationConfigurationApiType = {
		tenant: null,
		ruleId: elementsReco ? elementsReco[0].Id : '',
		numberOfProducts: elementsReco ? elementsReco[0].NumberOfProducts : null,
		personalisationParameterName: emailTemplate.PersonalisationParameterName ?? ''
	};



	return {
		baseTemplateId: emailTemplate.Id,
		name: emailTemplate.Name,
		description: emailTemplate.Description,
		recommendationConfiguration: isRecoValid ? recommendationConfig : null,
		templateProperties: convertToTemplatePropertyValue(emailTemplate.Properties),
		providerConfiguration: emailTemplate.ProviderConfiguration
	};
}



function convertToTemplatePropertyValue(arrayOfProperties: TemplateProperty[]) {
	let newListProperties: TemplatePropertiesValue[] = [];
	newListProperties = arrayOfProperties.map((property: TemplateProperty) => {
		const newObjectValue: TemplatePropertiesValue = {
			name: property.Name,
			value: property.Value,
			isGroup: property.IsGroup,
			isCollection: property.IsCollection
		};
		return newObjectValue;
	});
	return newListProperties;
}



export function convertEmailTemplateForUpdate(emailTemplate: EmailTemplateObject): UpdateEmailTemplateApiType {
	const reco = convertRecommendationCfg(emailTemplate.Properties);
	const cleanedReco = reco ? reco.trim().replace(/[\u200B-\u200D\uFEFF\s]/g, '') : '';
	const isRecoValid = typeof cleanedReco === 'string' && cleanedReco.length > 0 && cleanedReco !== '""';
	
	let elementsReco: any = null;
	try {
		elementsReco = isRecoValid ? JSON.parse(cleanedReco) : null;
	} catch (e) {
		console.error('=>(TypeAdapters.tsx:57) JSON.parse error', e);
	}

	const recommendationConfig: RecommendationConfigurationApiType = {
		tenant: null,
		ruleId: elementsReco ? elementsReco[0].Id : '',
		numberOfProducts: elementsReco ? elementsReco[0].NumberOfProducts : null,
		personalisationParameterName: emailTemplate.PersonalisationParameterName ?? ''
	};
	return {
		status: emailTemplate.Status,
		name: emailTemplate.Name,
		description: emailTemplate.Description,
		recommendationConfiguration: isRecoValid ? recommendationConfig : null,
		templateProperties: convertToTemplatePropertyValue(emailTemplate.Properties),
		providerConfiguration: emailTemplate.ProviderConfiguration
	};
}


// export const payloadExample = {
// 	"BespokeTemplates": [
// 	  {
// 		"Key": "d6b37728-20bc-4a3c-b9b9-ec06812ee11c",
// 		"Name": "Popup with image",
// 		"Description": "Popup with image",
// 		"Identifier": "O_G_0009_POPIN_IMAGE",
// 		"Type": "CallToAction",
// 		"Format": "OVERLAY",
// 		"ThumbnailUrl": "https://beyabledev.blob.core.windows.net/displaylibrary/0000000a-0000-0000-0000-000000000000/thumbnails/O_G_0009_POPIN_IMAGE.png?sv=2021-04-10&st=2022-08-30T11%3A41%3A54Z&se=2023-01-03T12%3A41%3A00Z&sr=c&sp=rl&sig=K6Ga7BAR08%2BaQBMNqBoNZ80cT4Ywpa%2BQR7piAjmCGVA%3D",
// 		"CustomCssEnabled": true,
// 		"MobileVersionEnabled": true,
// 		"WysiwygTemplateType": 2,
// 		"TemplateDescriptorDesktop": {
// 		  "HtmlPreview": "<div id=\"by_sld{{SId}}\"></div>",
// 		  "Css": "/* FONT */\r\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap');\r\n/* RESET */\r\n.by_O_G_0009,\r\n.by_O_G_0009 *{\r\n    all: revert;\r\n}\r\n.by_O_G_0009{\r\n    line-height: 1.4;\r\n}\r\n.by_O_G_0009 * {\r\n    box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    -o-box-sizing: border-box;\r\n    background: 0 0;\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    outline: none;\r\n    font: inherit;\r\n    color: inherit;\r\n    vertical-align: baseline;\r\n}\r\n.by_O_G_0009 span {\r\n    display: inline;\r\n    color: inherit;\r\n}\r\n.by_O_G_0009 button {\r\n    display: inline-block;\r\n    cursor: pointer;\r\n}\r\n.by_O_G_0009 ol,\r\n.by_O_G_0009 ul {\r\n    list-style: none;\r\n}\r\n.by_O_G_0009 strong{\r\n    font-weight: bold;\r\n}\r\n.by_O_G_0009 em{\r\n    font-style: italic;\r\n}\r\n.by_O_G_0009 a{\r\n    cursor: pointer;\r\n}\r\n.by_O_G_0009 a,\r\n.by_O_G_0009 a:hover,\r\n.by_O_G_0009 a:visited {\r\n    text-decoration: none;\r\n}\r\n/* DEVICE BREAKPOINT */\r\n@media (max-width: 768px){\r\n    .by_O_G_0009 .by_desktop{\r\n        display: none;\r\n    }\r\n}\r\n@media (min-width: 769px){\r\n    .by_O_G_0009 .by_mobile{\r\n        display: none;\r\n    }\r\n}\r\n/* POPIN */\r\n.by_O_G_0009 .by_popin{\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 2147483647;\r\n    overflow-y: auto;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    padding: 38px 16px;\r\n    -webkit-transition: visibility 400ms ease, opacity 400ms ease;\r\n    -o-transition: visibility 400ms ease, opacity 400ms ease;\r\n    transition: visibility 400ms ease, opacity 400ms ease;\r\n    /* before opening */\r\nvisibility: hidden;\r\n    opacity: 0;\r\n}\r\n.by_O_G_0009.by_is_open .by_popin{\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n/* POPIN INNER */\r\n.by_O_G_0009 .by_popin_inner{\r\n    -webkit-box-flex: 0;\r\n    -ms-flex: 0 0 auto;\r\n    flex: 0 0 auto;\r\n    margin: auto;\r\n    position: relative;\r\n    z-index: 2;\r\n    max-width: 100%;\r\n    -webkit-transition: -webkit-transform 400ms ease;\r\n    transition: -webkit-transform 400ms ease;\r\n    -o-transition: transform 400ms ease;\r\n    transition: transform 400ms ease;\r\n    transition: transform 400ms ease, -webkit-transform 400ms ease;\r\n    /* popin style */\r\n display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: stretch;\r\n    -ms-flex-align: stretch;\r\n    align-items: stretch;\r\n    font-family: Montserrat, Helvetica, arial, sans-serif;\r\n    /* before opening */\r\n-webkit-transform: translateY(-80px);\r\n    -ms-transform: translateY(-80px);\r\n    transform: translateY(-80px);\r\n}\r\n.by_O_G_0009.by_is_open .by_popin_inner{\r\n    -webkit-transform: translateY(0);\r\n    -ms-transform: translateY(0);\r\n    transform: translateY(0);\r\n}\r\n/* Layout */\r\n.by_O_G_0009 .by_img{\r\n    position: relative;\r\n    -webkit-box-flex: 0;\r\n    -ms-flex: 0 0 auto;\r\n    flex: 0 0 auto;\r\n    height: auto;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    border-radius: inherit;\r\n}\r\n.by_O_G_0009 .by_img img{\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    display: block;\r\n}\r\n.by_O_G_0009 .by_clickable{\r\n    cursor: pointer;\r\n}\r\n/* CLOSE */\r\n.by_O_G_0009 .by_close{\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: -36px;\r\n    right: -10px;\r\n    cursor: pointer;\r\n    color: #fff;\r\n    padding: 8px;\r\n}\r\n.by_O_G_0009 .by_close_label{\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    line-height: 20px;\r\n}\r\n.by_O_G_0009 .by_close_icon{\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    width: 20px;\r\n    height: 20px;\r\n    position: relative;\r\n}\r\n.by_O_G_0009 .by_close,\r\n.by_O_G_0009 .by_close_icon{\r\n    -webkit-transition: all 100ms;\r\n    -o-transition: all 100ms;\r\n    transition: all 100ms;\r\n}\r\n.by_O_G_0009 .by_close_icon::before,\r\n.by_O_G_0009 .by_close_icon::after{\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transition: all .2s ease;\r\n    -o-transition: all .2s ease;\r\n    transition: all .2s ease;\r\n    -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    border-radius: 3px;\r\n    background: currentColor;\r\n}\r\n.by_O_G_0009 .by_close_icon::before{\r\n    width: 2px;\r\n    height: 13px;\r\n}\r\n.by_O_G_0009 .by_close_icon::after{\r\n    width: 13px;\r\n    height: 2px;\r\n}"
// 		},
// 		"TemplateDescriptorMobile": {
// 		  "HtmlPreview": "<div id=\"by_sld{{SId}}\"></div>",
// 		  "Css": "/* FONT */\r\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap');\r\n/* RESET */\r\n.by_O_G_0009,\r\n.by_O_G_0009 *{\r\n    all: revert;\r\n}\r\n.by_O_G_0009{\r\n    line-height: 1.4;\r\n}\r\n.by_O_G_0009 * {\r\n    box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    -o-box-sizing: border-box;\r\n    background: 0 0;\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    outline: none;\r\n    font: inherit;\r\n    color: inherit;\r\n    vertical-align: baseline;\r\n}\r\n.by_O_G_0009 span {\r\n    display: inline;\r\n    color: inherit;\r\n}\r\n.by_O_G_0009 button {\r\n    display: inline-block;\r\n    cursor: pointer;\r\n}\r\n.by_O_G_0009 ol,\r\n.by_O_G_0009 ul {\r\n    list-style: none;\r\n}\r\n.by_O_G_0009 strong{\r\n    font-weight: bold;\r\n}\r\n.by_O_G_0009 em{\r\n    font-style: italic;\r\n}\r\n.by_O_G_0009 a{\r\n    cursor: pointer;\r\n}\r\n.by_O_G_0009 a,\r\n.by_O_G_0009 a:hover,\r\n.by_O_G_0009 a:visited {\r\n    text-decoration: none;\r\n}\r\n/* DEVICE BREAKPOINT */\r\n@media (max-width: 768px){\r\n    .by_O_G_0009 .by_desktop{\r\n        display: none;\r\n    }\r\n}\r\n@media (min-width: 769px){\r\n    .by_O_G_0009 .by_mobile{\r\n        display: none;\r\n    }\r\n}\r\n/* POPIN */\r\n.by_O_G_0009 .by_popin{\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 2147483647;\r\n    overflow-y: auto;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    padding: 38px 16px;\r\n    -webkit-transition: visibility 400ms ease, opacity 400ms ease;\r\n    -o-transition: visibility 400ms ease, opacity 400ms ease;\r\n    transition: visibility 400ms ease, opacity 400ms ease;\r\n    /* before opening */\r\nvisibility: hidden;\r\n    opacity: 0;\r\n}\r\n.by_O_G_0009.by_is_open .by_popin{\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n/* POPIN INNER */\r\n.by_O_G_0009 .by_popin_inner{\r\n    -webkit-box-flex: 0;\r\n    -ms-flex: 0 0 auto;\r\n    flex: 0 0 auto;\r\n    margin: auto;\r\n    position: relative;\r\n    z-index: 2;\r\n    max-width: 100%;\r\n    -webkit-transition: -webkit-transform 400ms ease;\r\n    transition: -webkit-transform 400ms ease;\r\n    -o-transition: transform 400ms ease;\r\n    transition: transform 400ms ease;\r\n    transition: transform 400ms ease, -webkit-transform 400ms ease;\r\n    /* popin style */\r\n display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: stretch;\r\n    -ms-flex-align: stretch;\r\n    align-items: stretch;\r\n    font-family: Montserrat, Helvetica, arial, sans-serif;\r\n    /* before opening */\r\n-webkit-transform: translateY(-80px);\r\n    -ms-transform: translateY(-80px);\r\n    transform: translateY(-80px);\r\n}\r\n.by_O_G_0009.by_is_open .by_popin_inner{\r\n    -webkit-transform: translateY(0);\r\n    -ms-transform: translateY(0);\r\n    transform: translateY(0);\r\n}\r\n/* Layout */\r\n.by_O_G_0009 .by_img{\r\n    position: relative;\r\n    -webkit-box-flex: 0;\r\n    -ms-flex: 0 0 auto;\r\n    flex: 0 0 auto;\r\n    height: auto;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    border-radius: inherit;\r\n}\r\n.by_O_G_0009 .by_img img{\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    display: block;\r\n}\r\n.by_O_G_0009 .by_clickable{\r\n    cursor: pointer;\r\n}\r\n/* CLOSE */\r\n.by_O_G_0009 .by_close{\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: -36px;\r\n    right: -10px;\r\n    cursor: pointer;\r\n    color: #fff;\r\n    padding: 8px;\r\n}\r\n.by_O_G_0009 .by_close_label{\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    line-height: 20px;\r\n}\r\n.by_O_G_0009 .by_close_icon{\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    width: 20px;\r\n    height: 20px;\r\n    position: relative;\r\n}\r\n.by_O_G_0009 .by_close,\r\n.by_O_G_0009 .by_close_icon{\r\n    -webkit-transition: all 100ms;\r\n    -o-transition: all 100ms;\r\n    transition: all 100ms;\r\n}\r\n.by_O_G_0009 .by_close_icon::before,\r\n.by_O_G_0009 .by_close_icon::after{\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transition: all .2s ease;\r\n    -o-transition: all .2s ease;\r\n    transition: all .2s ease;\r\n    -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    border-radius: 3px;\r\n    background: currentColor;\r\n}\r\n.by_O_G_0009 .by_close_icon::before{\r\n    width: 2px;\r\n    height: 13px;\r\n}\r\n.by_O_G_0009 .by_close_icon::after{\r\n    width: 13px;\r\n    height: 2px;\r\n}"
// 		},
// 		"Properties": [
// 		  {
// 			"Name": "IMG",
// 			"FriendlyName": "Image",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"Content": [
// 			  {
// 				"Name": "IMG_DESK",
// 				"Device": "desktop",
// 				"Value": "https://tag.beyable.com/assets/0000000a-0000-0000-0000-000000000000/logo-5197067e-569f-4371-b372-b0481904330c.png",
// 				"FriendlyName": "Upload image",
// 				"Editor": {
// 				  "Type": "Image"
// 				}
// 			  },
// 			  {
// 				"Name": "IMG_WIDTH_DESK",
// 				"Device": "desktop",
// 				"Value": 700,
// 				"FriendlyName": "Width",
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 100,
// 				  "Max": 1000,
// 				  "Unit": "px"
// 				}
// 			  },
// 			  {
// 				"Name": "IMG_MOB",
// 				"Device": "mobile",
// 				"Value": "https://tag.beyable.com/assets/0000000a-0000-0000-0000-000000000000/logo-6fecb010-83eb-4485-bf8b-cb9a3b511f73.png",
// 				"FriendlyName": "Upload image",
// 				"Editor": {
// 				  "Type": "Image"
// 				}
// 			  },
// 			  {
// 				"Name": "IMG_WIDTH_MOB",
// 				"Device": "mobile",
// 				"Value": 300,
// 				"FriendlyName": "Width",
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 100,
// 				  "Max": 500,
// 				  "Unit": "px"
// 				}
// 			  },
// 			  {
// 				"Name": "BORDER_RADIUS",
// 				"Value": 12,
// 				"FriendlyName": "Border radius",
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 0,
// 				  "Max": 50,
// 				  "Unit": "px"
// 				}
// 			  },
// 			  {
// 				"Name": "ACTIVE_BACKGROUND_IMG",
// 				"FriendlyName": "Background color",
// 				"Value": false,
// 				"Editor": {
// 				  "Type": "Boolean"
// 				}
// 			  },
// 			  {
// 				"Name": "BG_COLOR_IMG",
// 				"Value": "#FFFFFF",
// 				"FriendlyName": "Background color",
// 				"Description": "For images with transparency",
// 				"Editor": {
// 				  "Type": "ColorPicker",
// 				  "Width": "m",
// 				  "Float": true
// 				},
// 				"Dependency": {
// 				  "Property": "IMG.ACTIVE_BACKGROUND_IMG",
// 				  "Value": true
// 				}
// 			  },
// 			  {
// 				"Name": "ACTIVE_SHADOW",
// 				"FriendlyName": "Shadow",
// 				"Value": true,
// 				"Editor": {
// 				  "Type": "Boolean"
// 				}
// 			  }
// 			]
// 		  },
// 		  {
// 			"Name": "CTA",
// 			"FriendlyName": "Click on image",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"Content": [
// 			  {
// 				"Name": "URL",
// 				"Value": "",
// 				"FriendlyName": "Redirect URL",
// 				"SubDescription": "Leave empty to close popin",
// 				"Editor": {
// 				  "Type": "Text"
// 				}
// 			  },
// 			  {
// 				"Name": "NEW_TAB",
// 				"Value": false,
// 				"FriendlyName": "Open in a new tab",
// 				"Editor": {
// 				  "Type": "Boolean"
// 				}
// 			  }
// 			]
// 		  },
// 		  {
// 			"Name": "CLOSE",
// 			"FriendlyName": "Close button",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"IsActiveProperty": {
// 			  "Name": "ISACTIVE",
// 			  "Value": true
// 			},
// 			"Content": [
// 			  {
// 				"Name": "LABEL",
// 				"Value": "Fermer",
// 				"FriendlyName": "Text",
// 				"Editor": {
// 				  "Type": "Text"
// 				}
// 			  },
// 			  {
// 				"Name": "COLOR",
// 				"Value": "#FFFFFF",
// 				"FriendlyName": "Color",
// 				"Editor": {
// 				  "Type": "ColorPicker",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  }
// 			]
// 		  },
// 		  {
// 			"Name": "OVERLAY",
// 			"FriendlyName": "Overlay",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"Content": [
// 			  {
// 				"Name": "BG_COLOR",
// 				"Value": "rgba(0,0,0,.5)",
// 				"FriendlyName": "Backgroud color",
// 				"Editor": {
// 				  "Type": "ColorPicker",
// 				  "Width": "l",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "CLICK_TO_CLOSE",
// 				"Value": true,
// 				"FriendlyName": "Click on overlay to close popin",
// 				"Editor": {
// 				  "Type": "Boolean"
// 				}
// 			  }
// 			]
// 		  },
// 		  {
// 			"Name": "TRACKING",
// 			"FriendlyName": "Tracking URLs",
// 			"Tooltip": "The tracking links can be set-up through affiliation platforms and they are used to trace the post-click conversions. All tracking links contain the affiliate's number, which allows the platform to attribute sales to the leverage that contributed to them. Tracking links are used for CPA (% commission on sale) or CPL (cost per lead) remuneration.",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"IsActiveProperty": {
// 			  "Name": "ISACTIVE",
// 			  "Value": false
// 			},
// 			"Content": [
// 			  {
// 				"Name": "CLICK_CTA_URL",
// 				"Value": "",
// 				"FriendlyName": "After clicking on call to action",
// 				"Editor": {
// 				  "Type": "Text"
// 				}
// 			  }
// 			]
// 		  }
// 		],
// 		"WysiwygDesktop": {
// 		  "Template": "<style>\n{{Css}}\n\n.by_O_G_0009 {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: url(https://az691294.vo.msecnd.net/assets/0000000a-0000-0000-0000-000000000000/logo-111f5355-f559-49a6-aaba-3aec05d01344.png);\n    background-position: center top;\n    background-size: cover;\n}\n.by_O_G_0009 .by_popin{\n\tposition: absolute !important;\n\tz-index: 1 !important;\n\tvisibility: visible !important;\n\topacity: 1 !important;\n\tbackground: {{OVERLAY.BG_COLOR}};\n}\n.by_O_G_0009 .by_popin_inner{\n\tborder-radius: {{IMG.BORDER_RADIUS}}px;\n\t{% if IMG.ACTIVE_BACKGROUND_IMG %} background: {{IMG.BG_COLOR_IMG}}; {% endif %}\n}\n.by_O_G_0009 .by_close{\n\tcolor: {{CLOSE.COLOR}};\n}\n.by_O_G_0009 .by_img.by_desktop{\n\twidth: {{IMG.IMG_WIDTH_DESK}}px;\n}\n.by_O_G_0009 .by_img.by_mobile{\n\twidth: {{IMG.IMG_WIDTH_MOB}}px;\n}\n{% if IMG.ACTIVE_SHADOW %}\n\t.by_O_G_0009 .by_popin_inner{\n\t\t-webkit-box-shadow: rgba(0,0,0,.2) 0 0 20px;\n\t\tbox-shadow: rgba(0,0,0,.2) 0 0 20px;\n\t}\n{% endif %}\n</style>\n\n<div class=\"by_O_G_0009 by_is_open\">\n\t<div class=\"by_popin\">\n\t\t<div class=\"by_popin_inner\">\n\n\t\t\t{% if CLOSE.ISACTIVE %}\n\t\t\t\t<a class=\"by_close\">\n\t\t\t\t\t<span class=\"by_close_label\">{{CLOSE.LABEL}}</span>\n\t\t\t\t\t<span class=\"by_close_icon\"></span>\n\t\t\t\t</a>\n\t\t\t{% endif %}\n\n\t\t\t<div class=\"by_img by_desktop\">\n\t\t\t\t<img src=\"{{IMG.IMG_DESK}}\">\n\t\t\t</div>\n\n\t\t\t<div class=\"by_img by_mobile\">\n\t\t\t\t<img src=\"{{IMG.IMG_MOB}}\">\n\t\t\t</div>\n\t\t\t\n\t\t</div>\n\t</div>\n</div>",
// 		  "WysiwygMobileTemplateType": 2
// 		},
// 		"WysiwygMobile": {
// 		  "Template": "<style>\n{{Css}}\n\n.by_O_G_0009 {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: url(https://az691294.vo.msecnd.net/assets/0000000a-0000-0000-0000-000000000000/logo-111f5355-f559-49a6-aaba-3aec05d01344.png);\n    background-position: center top;\n    background-size: cover;\n}\n.by_O_G_0009 .by_popin{\n\tposition: absolute !important;\n\tz-index: 1 !important;\n\tvisibility: visible !important;\n\topacity: 1 !important;\n\tbackground: {{OVERLAY.BG_COLOR}};\n}\n.by_O_G_0009 .by_popin_inner{\n\tborder-radius: {{IMG.BORDER_RADIUS}}px;\n\t{% if IMG.ACTIVE_BACKGROUND_IMG %} background: {{IMG.BG_COLOR_IMG}}; {% endif %}\n}\n.by_O_G_0009 .by_close{\n\tcolor: {{CLOSE.COLOR}};\n}\n.by_O_G_0009 .by_img.by_desktop{\n\twidth: {{IMG.IMG_WIDTH_DESK}}px;\n}\n.by_O_G_0009 .by_img.by_mobile{\n\twidth: {{IMG.IMG_WIDTH_MOB}}px;\n}\n{% if IMG.ACTIVE_SHADOW %}\n\t.by_O_G_0009 .by_popin_inner{\n\t\t-webkit-box-shadow: rgba(0,0,0,.2) 0 0 20px;\n\t\tbox-shadow: rgba(0,0,0,.2) 0 0 20px;\n\t}\n{% endif %}\n</style>\n\n<div class=\"by_O_G_0009 by_is_open\">\n\t<div class=\"by_popin\">\n\t\t<div class=\"by_popin_inner\">\n\n\t\t\t{% if CLOSE.ISACTIVE %}\n\t\t\t\t<a class=\"by_close\">\n\t\t\t\t\t<span class=\"by_close_label\">{{CLOSE.LABEL}}</span>\n\t\t\t\t\t<span class=\"by_close_icon\"></span>\n\t\t\t\t</a>\n\t\t\t{% endif %}\n\n\t\t\t<div class=\"by_img by_desktop\">\n\t\t\t\t<img src=\"{{IMG.IMG_DESK}}\">\n\t\t\t</div>\n\n\t\t\t<div class=\"by_img by_mobile\">\n\t\t\t\t<img src=\"{{IMG.IMG_MOB}}\">\n\t\t\t</div>\n\t\t\t\n\t\t</div>\n\t</div>\n</div>",
// 		  "WysiwygMobileTemplateType": 2
// 		}
// 	  }
// 	],
// 	"Identifier": "popin_with_image",
// 	"Triggers": []
// };


// export const payloadExample = {
// 	"BespokeTemplates": [
// 	  {
// 		"Key": "990ad09f-c595-4b22-8c7f-3b10d80353a7",
// 		"Name": "Header bar with countdown",
// 		"Description": "Header bar with countdown",
// 		"Identifier": "HB_G_0001_HEADERBAR_COUNTDOWN",
// 		"Type": "CallToAction",
// 		"Format": "HEADERBAR",
// 		"ThumbnailUrl": "https://beyabledev.blob.core.windows.net/displaylibrary/0000000a-0000-0000-0000-000000000000/thumbnails/HB_G_0001_HEADERBAR_COUNTDOWN.png?sv=2021-04-10&st=2022-08-30T11%3A41%3A54Z&se=2023-01-03T12%3A41%3A00Z&sr=c&sp=rl&sig=K6Ga7BAR08%2BaQBMNqBoNZ80cT4Ywpa%2BQR7piAjmCGVA%3D",
// 		"CustomCssEnabled": true,
// 		"MobileVersionEnabled": true,
// 		"WysiwygTemplateType": 2,
// 		"TemplateDescriptorDesktop": {
// 		  "HtmlPreview": "<div id=\"by_sld{{SId}}\"></div>",
// 		  "Css": "/* FONT */\r\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap');\r\n/* RESET */\r\n.by_HB_G_0001{\r\n    line-height: 1.4;\r\n    font-family: Montserrat, sans-serif;\r\n}\r\n.by_HB_G_0001,\r\n.by_HB_G_0001 * {\r\n    box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    -o-box-sizing: border-box;\r\n}\r\n.by_HB_G_0001 * {\r\n    background: 0 0;\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    font: inherit;\r\n    vertical-align: baseline;\r\n    font-family: inherit;\r\n}\r\n.by_HB_G_0001 span {\r\n    display: inline;\r\n    color: inherit;\r\n}\r\n.by_HB_G_0001 button {\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: inherit;\r\n}\r\n.by_HB_G_0001 ol,\r\n.by_HB_G_0001 ul {\r\n    list-style: none;\r\n}\r\n.by_HB_G_0001 strong{\r\n    font-weight: 700;\r\n}\r\n.by_HB_G_0001 em{\r\n    font-style: italic;\r\n}\r\n.by_HB_G_0001 a{\r\n    cursor: pointer;\r\n}\r\n.by_HB_G_0001 a,\r\n.by_HB_G_0001 a:hover,\r\n.by_HB_G_0001 a:visited {\r\n    text-decoration: none;\r\n}\r\n/* DEVICE BREAKPOINT */\r\n@media (max-width: 768px) {\r\n    .by_HB_G_0001 .by_desktop{\r\n        display: none !important;\r\n    }\r\n}\r\n@media (min-width: 769px){\r\n    .by_HB_G_0001 .by_mobile{\r\n        display: none !important;\r\n    }\r\n}\r\n/* Wrapper */\r\n.by_HB_G_0001,\r\n.by_HB_G_0001_pusher{\r\n    min-height: 48px;\r\n}\r\n.by_HB_G_0001{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 2147483647;\r\n    display: flex;\r\n    align-items: center;\r\n    background: #E65540;\r\n    color: #fff;\r\n    padding: 8px 30px;\r\n    font-size: 13px;\r\n}\r\n@media (min-width: 769px) {\r\n    .by_HB_G_0001.by_position_footer{\r\n        position: fixed;\r\n        top: auto;\r\n        bottom: 0;\r\n    }\r\n    .by_HB_G_0001.by_position_header_sticky{\r\n        position: fixed;\r\n    }\r\n}\r\n@media (max-width: 768px) {\r\n    .by_HB_G_0001.by_position_mob_footer{\r\n        position: fixed;\r\n        top: auto;\r\n        bottom: 0;\r\n    }\r\n    .by_HB_G_0001.by_position_mob_header_sticky{\r\n        position: fixed;\r\n    }\r\n}\r\n/* Pusher */\r\n.by_HB_G_0001_pusher{\r\n    display: block;\r\n    width: 100%;\r\n    flex: 0 0 auto;\r\n}\r\n/* Layout */\r\n.by_HB_G_0001 .by_content{\r\n    flex: 1 1 auto;\r\n    margin: auto;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.by_HB_G_0001 .by_col_main{\r\n    flex: 0 1 auto;\r\n}\r\n.by_HB_G_0001 .by_col_cta{\r\n    flex: 0 0 auto;\r\n    margin-left: 14px;\r\n}\r\n.by_HB_G_0001 .by_col_text,\r\n.by_HB_G_0001 .by_col_text p,\r\n.by_HB_G_0001 .by_col_countdown{\r\n    display: inline-block;\r\n    vertical-align: baseline;\r\n}\r\n@media (max-width: 768px) {\r\n    .by_HB_G_0001.by_layout_mob_left{\r\n        padding-left: 16px;\r\n    }\r\n    .by_HB_G_0001.by_layout_mob_center .by_content{\r\n        text-align: center;\r\n    }\r\n    .by_HB_G_0001 .by_content{\r\n        display: block;\r\n    }\r\n    .by_HB_G_0001 .by_col_cta{\r\n        margin-top: 8px;\r\n        margin-left: 0;\r\n    }\r\n}\r\n/* CTA */\r\n.by_HB_G_0001 .by_cta{\r\n    display: inline-block;\r\n    border: solid 1px currentColor;\r\n    border-radius: 5px;\r\n    line-height: 1;\r\n    padding: 8px 10px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    color: #fff;\r\n}\r\n.by_HB_G_0001 .by_cta:hover,\r\n.by_HB_G_0001 .by_cta:focus{\r\n    text-decoration: none;\r\n}\r\n/* Countdown */\r\n.by_HB_G_0001 .by_countdown{\r\n    white-space: nowrap;\r\n    line-height: 1;\r\n    display: inline-flex;\r\n}\r\n.by_HB_G_0001 .by_countdown_item{\r\n    flex: 0 0 auto;\r\n    text-align: center;\r\n    margin: 0 3px;\r\n}\r\n.by_HB_G_0001 .by_countdown_value{\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n}\r\n.by_HB_G_0001 .by_countdown_label{\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n}\r\n/* CODE */\r\n.by_HB_G_0001 .by_code_wrapper{\r\n    position: relative;\r\n    display: inline-block;\r\n    margin-left: 10px;\r\n}\r\n[dir=\"rtl\"] .by_HB_G_0001 .by_code_wrapper{\r\n    margin-left: 0;\r\n    margin-right: 10px;\r\n}\r\n.by_HB_G_0001 .by_code{\r\n    display: inline-block;\r\n    border: solid 1px currentColor;\r\n    border-radius: 50px;\r\n    line-height: 1;\r\n    padding: 5px 10px;\r\n    font-size: 13px;\r\n    cursor: pointer;\r\n}\r\n.by_HB_G_0001 .by_tooltip{\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 100%;\r\n    background: #000;\r\n    color: #FFF;\r\n    font-size: 12px;\r\n    text-align: center;\r\n    padding: 4px 12px;\r\n    border-radius: 50px;\r\n    white-space: nowrap;\r\n    transform: translateX(-50%);\r\n    pointer-events: none;\r\n    transition: all 200ms;\r\n    margin-top: -20px;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n}\r\n.by_HB_G_0001 .by_tooltip.by_visible{\r\n    margin-top: 4px;\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n/* Close */\r\n.by_HB_G_0001 .by_close{\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n[dir=\"rtl\"] .by_HB_G_0001 .by_close{\r\n    right: auto;\r\n    left: 0;\r\n}\r\n.by_HB_G_0001 .by_close_inner{\r\n    position: relative;\r\n    width: 40px;\r\n    height: 40px;\r\n    cursor: pointer;\r\n}\r\n.by_HB_G_0001 .by_close_inner::before,\r\n.by_HB_G_0001 .by_close_inner::after{\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transition: all .2s ease;\r\n    -o-transition: all .2s ease;\r\n    transition: all .2s ease;\r\n    -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    border-radius: 3px;\r\n    background: currentColor;\r\n}\r\n.by_HB_G_0001 .by_close_inner::before{\r\n    width: 2px;\r\n    height: 14px;\r\n}\r\n.by_HB_G_0001 .by_close_inner::after{\r\n    width: 14px;\r\n    height: 2px;\r\n}"
// 		},
// 		"TemplateDescriptorMobile": {
// 		  "HtmlPreview": "<div id=\"by_sld{{SId}}\"></div>",
// 		  "Css": "/* FONT */\r\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap');\r\n/* RESET */\r\n.by_HB_G_0001{\r\n    line-height: 1.4;\r\n    font-family: Montserrat, sans-serif;\r\n}\r\n.by_HB_G_0001,\r\n.by_HB_G_0001 * {\r\n    box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    -o-box-sizing: border-box;\r\n}\r\n.by_HB_G_0001 * {\r\n    background: 0 0;\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    font: inherit;\r\n    vertical-align: baseline;\r\n    font-family: inherit;\r\n}\r\n.by_HB_G_0001 span {\r\n    display: inline;\r\n    color: inherit;\r\n}\r\n.by_HB_G_0001 button {\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: inherit;\r\n}\r\n.by_HB_G_0001 ol,\r\n.by_HB_G_0001 ul {\r\n    list-style: none;\r\n}\r\n.by_HB_G_0001 strong{\r\n    font-weight: 700;\r\n}\r\n.by_HB_G_0001 em{\r\n    font-style: italic;\r\n}\r\n.by_HB_G_0001 a{\r\n    cursor: pointer;\r\n}\r\n.by_HB_G_0001 a,\r\n.by_HB_G_0001 a:hover,\r\n.by_HB_G_0001 a:visited {\r\n    text-decoration: none;\r\n}\r\n/* DEVICE BREAKPOINT */\r\n@media (max-width: 768px) {\r\n    .by_HB_G_0001 .by_desktop{\r\n        display: none !important;\r\n    }\r\n}\r\n@media (min-width: 769px){\r\n    .by_HB_G_0001 .by_mobile{\r\n        display: none !important;\r\n    }\r\n}\r\n/* Wrapper */\r\n.by_HB_G_0001,\r\n.by_HB_G_0001_pusher{\r\n    min-height: 48px;\r\n}\r\n.by_HB_G_0001{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 2147483647;\r\n    display: flex;\r\n    align-items: center;\r\n    background: #E65540;\r\n    color: #fff;\r\n    padding: 8px 30px;\r\n    font-size: 13px;\r\n}\r\n@media (min-width: 769px) {\r\n    .by_HB_G_0001.by_position_footer{\r\n        position: fixed;\r\n        top: auto;\r\n        bottom: 0;\r\n    }\r\n    .by_HB_G_0001.by_position_header_sticky{\r\n        position: fixed;\r\n    }\r\n}\r\n@media (max-width: 768px) {\r\n    .by_HB_G_0001.by_position_mob_footer{\r\n        position: fixed;\r\n        top: auto;\r\n        bottom: 0;\r\n    }\r\n    .by_HB_G_0001.by_position_mob_header_sticky{\r\n        position: fixed;\r\n    }\r\n}\r\n/* Pusher */\r\n.by_HB_G_0001_pusher{\r\n    display: block;\r\n    width: 100%;\r\n    flex: 0 0 auto;\r\n}\r\n/* Layout */\r\n.by_HB_G_0001 .by_content{\r\n    flex: 1 1 auto;\r\n    margin: auto;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.by_HB_G_0001 .by_col_main{\r\n    flex: 0 1 auto;\r\n}\r\n.by_HB_G_0001 .by_col_cta{\r\n    flex: 0 0 auto;\r\n    margin-left: 14px;\r\n}\r\n.by_HB_G_0001 .by_col_text,\r\n.by_HB_G_0001 .by_col_text p,\r\n.by_HB_G_0001 .by_col_countdown{\r\n    display: inline-block;\r\n    vertical-align: baseline;\r\n}\r\n@media (max-width: 768px) {\r\n    .by_HB_G_0001.by_layout_mob_left{\r\n        padding-left: 16px;\r\n    }\r\n    .by_HB_G_0001.by_layout_mob_center .by_content{\r\n        text-align: center;\r\n    }\r\n    .by_HB_G_0001 .by_content{\r\n        display: block;\r\n    }\r\n    .by_HB_G_0001 .by_col_cta{\r\n        margin-top: 8px;\r\n        margin-left: 0;\r\n    }\r\n}\r\n/* CTA */\r\n.by_HB_G_0001 .by_cta{\r\n    display: inline-block;\r\n    border: solid 1px currentColor;\r\n    border-radius: 5px;\r\n    line-height: 1;\r\n    padding: 8px 10px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    color: #fff;\r\n}\r\n.by_HB_G_0001 .by_cta:hover,\r\n.by_HB_G_0001 .by_cta:focus{\r\n    text-decoration: none;\r\n}\r\n/* Countdown */\r\n.by_HB_G_0001 .by_countdown{\r\n    white-space: nowrap;\r\n    line-height: 1;\r\n    display: inline-flex;\r\n}\r\n.by_HB_G_0001 .by_countdown_item{\r\n    flex: 0 0 auto;\r\n    text-align: center;\r\n    margin: 0 3px;\r\n}\r\n.by_HB_G_0001 .by_countdown_value{\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n}\r\n.by_HB_G_0001 .by_countdown_label{\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n}\r\n/* CODE */\r\n.by_HB_G_0001 .by_code_wrapper{\r\n    position: relative;\r\n    display: inline-block;\r\n    margin-left: 10px;\r\n}\r\n[dir=\"rtl\"] .by_HB_G_0001 .by_code_wrapper{\r\n    margin-left: 0;\r\n    margin-right: 10px;\r\n}\r\n.by_HB_G_0001 .by_code{\r\n    display: inline-block;\r\n    border: solid 1px currentColor;\r\n    border-radius: 50px;\r\n    line-height: 1;\r\n    padding: 5px 10px;\r\n    font-size: 13px;\r\n    cursor: pointer;\r\n}\r\n.by_HB_G_0001 .by_tooltip{\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 100%;\r\n    background: #000;\r\n    color: #FFF;\r\n    font-size: 12px;\r\n    text-align: center;\r\n    padding: 4px 12px;\r\n    border-radius: 50px;\r\n    white-space: nowrap;\r\n    transform: translateX(-50%);\r\n    pointer-events: none;\r\n    transition: all 200ms;\r\n    margin-top: -20px;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n}\r\n.by_HB_G_0001 .by_tooltip.by_visible{\r\n    margin-top: 4px;\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n/* Close */\r\n.by_HB_G_0001 .by_close{\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n[dir=\"rtl\"] .by_HB_G_0001 .by_close{\r\n    right: auto;\r\n    left: 0;\r\n}\r\n.by_HB_G_0001 .by_close_inner{\r\n    position: relative;\r\n    width: 40px;\r\n    height: 40px;\r\n    cursor: pointer;\r\n}\r\n.by_HB_G_0001 .by_close_inner::before,\r\n.by_HB_G_0001 .by_close_inner::after{\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transition: all .2s ease;\r\n    -o-transition: all .2s ease;\r\n    transition: all .2s ease;\r\n    -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n    border-radius: 3px;\r\n    background: currentColor;\r\n}\r\n.by_HB_G_0001 .by_close_inner::before{\r\n    width: 2px;\r\n    height: 14px;\r\n}\r\n.by_HB_G_0001 .by_close_inner::after{\r\n    width: 14px;\r\n    height: 2px;\r\n}"
// 		},
// 		"Properties": [
// 		  {
// 			"Name": "CONTAINER",
// 			"FriendlyName": "Container",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"Content": [
// 			  {
// 				"Name": "HEIGHT",
// 				"FriendlyName": "Height",
// 				"Description": "Minimum height, content can increase this height.",
// 				"Device": "desktop",
// 				"Value": 48,
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 40,
// 				  "Max": 200,
// 				  "Unit": "px"
// 				}
// 			  },
// 			  {
// 				"Name": "HEIGHT_MOB",
// 				"FriendlyName": "Height",
// 				"Description": "Minimum height, content can increase this height.",
// 				"Device": "mobile",
// 				"Value": 100,
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 40,
// 				  "Max": 200,
// 				  "Unit": "px"
// 				}
// 			  },
// 			  {
// 				"Name": "BG_COLOR",
// 				"FriendlyName": "Background color",
// 				"Value": "#E65540",
// 				"Editor": {
// 				  "Type": "ColorPicker",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "POSITION",
// 				"FriendlyName": "Position",
// 				"Device": "desktop",
// 				"Value": "header",
// 				"Editor": {
// 				  "Type": "Select",
// 				  "AvailableValues": [
// 					{
// 					  "Label": "Header",
// 					  "Value": "header"
// 					},
// 					{
// 					  "Label": "Sticky header",
// 					  "Value": "header_sticky"
// 					},
// 					{
// 					  "Label": "Sticky footer",
// 					  "Value": "footer"
// 					}
// 				  ],
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "POSITION_MOB",
// 				"FriendlyName": "Position",
// 				"Device": "mobile",
// 				"Value": "header",
// 				"Editor": {
// 				  "Type": "Select",
// 				  "AvailableValues": [
// 					{
// 					  "Label": "Header",
// 					  "Value": "header"
// 					},
// 					{
// 					  "Label": "Sticky header",
// 					  "Value": "header_sticky"
// 					},
// 					{
// 					  "Label": "Sticky footer",
// 					  "Value": "footer"
// 					}
// 				  ],
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "LAYOUT_MOB",
// 				"FriendlyName": "Content alignment",
// 				"Device": "mobile",
// 				"Value": "left",
// 				"Editor": {
// 				  "Type": "Select",
// 				  "AvailableValues": [
// 					{
// 					  "Label": "Left",
// 					  "Value": "left"
// 					},
// 					{
// 					  "Label": "Center",
// 					  "Value": "center"
// 					}
// 				  ],
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  }
// 			]
// 		  },
// 		  {
// 			"Name": "BODY",
// 			"FriendlyName": "Main text",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"Content": [
// 			  {
// 				"Name": "TEXT1",
// 				"FriendlyName": "First text",
// 				"Device": "desktop",
// 				"Value": "<p><span style=\"font-size: 14px; font-family: Montserrat; color: #ffffff;\">Only</span></p>",
// 				"Editor": {
// 				  "Type": "RichText",
// 				  "Theme": "dark"
// 				}
// 			  },
// 			  {
// 				"Name": "TEXT2",
// 				"FriendlyName": "Last text",
// 				"Device": "desktop",
// 				"Value": "<p><span style=\"font-family: Montserrat; font-size: 14px; color: #ffffff;\">to take advantage of <span style=\"font-size: 18px;\"><strong>-10%</strong></span> on a category of products!</span></p>",
// 				"Editor": {
// 				  "Type": "RichText",
// 				  "Theme": "dark"
// 				}
// 			  },
// 			  {
// 				"Name": "TEXT1_MOB",
// 				"FriendlyName": "First text",
// 				"Device": "mobile",
// 				"Value": "<p><span style=\"font-size: 12px; font-family: Montserrat; color: #ffffff;\">Only</span></p>",
// 				"Editor": {
// 				  "Type": "RichText",
// 				  "Theme": "dark"
// 				}
// 			  },
// 			  {
// 				"Name": "TEXT2_MOB",
// 				"FriendlyName": "Last text",
// 				"Device": "mobile",
// 				"Value": "<p><span style=\"font-family: Montserrat; font-size: 12px; color: #ffffff;\">to take advantage of <span style=\"font-size: 15px;\"><strong>-10%</strong></span> on a category of products!</span></p>",
// 				"Editor": {
// 				  "Type": "RichText",
// 				  "Theme": "dark"
// 				}
// 			  }
// 			]
// 		  },
// 		  {
// 			"Name": "CTA",
// 			"FriendlyName": "Call to action",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"IsActiveProperty": {
// 			  "Name": "ISACTIVE",
// 			  "Value": true
// 			},
// 			"Content": [
// 			  {
// 				"Name": "TEXT",
// 				"Value": "DISCOVER",
// 				"Device": "desktop",
// 				"FriendlyName": "Text",
// 				"Editor": {
// 				  "Type": "Text"
// 				}
// 			  },
// 			  {
// 				"Name": "TEXT_MOB",
// 				"Value": "DISCOVER",
// 				"Device": "mobile",
// 				"FriendlyName": "Text",
// 				"Editor": {
// 				  "Type": "Text"
// 				}
// 			  },
// 			  {
// 				"Name": "URL",
// 				"Value": "",
// 				"FriendlyName": "Redirect URL",
// 				"SubDescription": "Leave empty to close popin",
// 				"Editor": {
// 				  "Type": "Text"
// 				}
// 			  },
// 			  {
// 				"Name": "NEW_TAB",
// 				"Value": false,
// 				"FriendlyName": "Open in a new tab",
// 				"Editor": {
// 				  "Type": "Boolean"
// 				}
// 			  },
// 			  {
// 				"Name": "FONT_SIZE",
// 				"FriendlyName": "Font size",
// 				"Device": "desktop",
// 				"Value": 14,
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 10,
// 				  "Max": 16,
// 				  "Unit": "px"
// 				}
// 			  },
// 			  {
// 				"Name": "FONT_SIZE_MOB",
// 				"FriendlyName": "Font size",
// 				"Device": "mobile",
// 				"Value": 12,
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 10,
// 				  "Max": 16,
// 				  "Unit": "px"
// 				}
// 			  },
// 			  {
// 				"Name": "BORDER_RADIUS",
// 				"FriendlyName": "Border radius",
// 				"Value": 5,
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 0,
// 				  "Max": 30,
// 				  "Unit": "px",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "BORDER_WIDTH",
// 				"FriendlyName": "Border width",
// 				"Value": 1,
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 0,
// 				  "Max": 2,
// 				  "Unit": "px",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "BG_COLOR",
// 				"FriendlyName": "Background color",
// 				"Value": "rgba(0,0,0,0)",
// 				"Editor": {
// 				  "Type": "ColorPicker",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "TXT_COLOR",
// 				"FriendlyName": "Text color",
// 				"Value": "#ffffff",
// 				"Editor": {
// 				  "Type": "ColorPicker",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "IS_BOLD",
// 				"FriendlyName": "Bold",
// 				"Value": true,
// 				"Editor": {
// 				  "Type": "Boolean",
// 				  "Width": "s",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "IS_UNDERLINE",
// 				"FriendlyName": "Underline",
// 				"Value": false,
// 				"Editor": {
// 				  "Type": "Boolean",
// 				  "Width": "s",
// 				  "Float": true
// 				}
// 			  }
// 			]
// 		  },
// 		  {
// 			"Name": "COUNTDOWN",
// 			"FriendlyName": "Countdown",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"MultiSteps": {
// 			  "Name": "STEP",
// 			  "FriendlyName": "Steps",
// 			  "Value": "style",
// 			  "Steps": {
// 				"style": "Style",
// 				"wording": "Wording",
// 				"date": "Date"
// 			  }
// 			},
// 			"Content": [
// 			  {
// 				"Name": "DATE",
// 				"FriendlyName": "End date",
// 				"Step": "date",
// 				"Value": "2022-07-02 11:15:00Z",
// 				"Editor": {
// 				  "Type": "CountDown",
// 				  "Timezone": "Europe/Paris",
// 				  "TimezoneSelector": true,
// 				  "IsAdvanced": true
// 				}
// 			  },
// 			  {
// 				"Name": "LABEL_DAY",
// 				"FriendlyName": "Unit text : days",
// 				"Value": "d",
// 				"Step": "wording",
// 				"Editor": {
// 				  "Type": "Text",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "LABEL_HOUR",
// 				"FriendlyName": "Unit text : hours",
// 				"Value": "h",
// 				"Step": "wording",
// 				"Editor": {
// 				  "Type": "Text",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "LABEL_MIN",
// 				"FriendlyName": "Unit text : minutes",
// 				"Value": "m",
// 				"Step": "wording",
// 				"Editor": {
// 				  "Type": "Text",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "LABEL_SEC",
// 				"FriendlyName": "Unit text : seconds",
// 				"Value": "s",
// 				"Step": "wording",
// 				"Editor": {
// 				  "Type": "Text",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "VALUE_TEXT_SIZE",
// 				"FriendlyName": "Value text size",
// 				"Device": "desktop",
// 				"Value": 16,
// 				"Step": "style",
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 10,
// 				  "Max": 20,
// 				  "Unit": "px",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "VALUE_TEXT_SIZE_MOB",
// 				"FriendlyName": "Value text size",
// 				"Device": "mobile",
// 				"Value": 14,
// 				"Step": "style",
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 10,
// 				  "Max": 20,
// 				  "Unit": "px",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "UNIT_TEXT_SIZE",
// 				"FriendlyName": "Unit text size",
// 				"Device": "desktop",
// 				"Value": 12,
// 				"Step": "style",
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 8,
// 				  "Max": 20,
// 				  "Unit": "px",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "UNIT_TEXT_SIZE_MOB",
// 				"FriendlyName": "Unit text size",
// 				"Device": "mobile",
// 				"Value": 10,
// 				"Step": "style",
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 8,
// 				  "Max": 20,
// 				  "Unit": "px",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "HIDE_SECONDS",
// 				"FriendlyName": "Show only 3 values",
// 				"Tooltip": "Less than a day left : Hours, Minutes and seconds.\n More than a day left : Days, Hours, Minutes",
// 				"Value": false,
// 				"Step": "style",
// 				"Editor": {
// 				  "Type": "Boolean"
// 				}
// 			  }
// 			]
// 		  },
// 		  {
// 			"Name": "CLOSE",
// 			"FriendlyName": "Close button",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"IsActiveProperty": {
// 			  "Name": "ISACTIVE",
// 			  "Value": true
// 			},
// 			"Content": [
// 			  {
// 				"Name": "COLOR",
// 				"Value": "#FFFFFF",
// 				"FriendlyName": "Color",
// 				"Editor": {
// 				  "Type": "ColorPicker",
// 				  "Width": "m",
// 				  "Float": true
// 				}
// 			  },
// 			  {
// 				"Name": "WIDTH",
// 				"FriendlyName": "Width",
// 				"Value": 14,
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 10,
// 				  "Max": 20,
// 				  "Unit": "px"
// 				}
// 			  },
// 			  {
// 				"Name": "THICKNESS",
// 				"FriendlyName": "Thickness",
// 				"Value": 2,
// 				"Editor": {
// 				  "Type": "Range",
// 				  "Min": 1,
// 				  "Max": 4,
// 				  "Unit": "px"
// 				}
// 			  },
// 			  {
// 				"Name": "ALIGN",
// 				"FriendlyName": "Vertical alignment",
// 				"Value": "center",
// 				"Editor": {
// 				  "Type": "ButtonGroup",
// 				  "AvailableValues": [
// 					{
// 					  "Label": "Center",
// 					  "Value": "center"
// 					},
// 					{
// 					  "Label": "Top",
// 					  "Value": "top"
// 					}
// 				  ]
// 				}
// 			  }
// 			]
// 		  },
// 		  {
// 			"Name": "TRACKING",
// 			"FriendlyName": "Tracking URLs",
// 			"Tooltip": "The tracking links can be set-up through affiliation platforms and they are used to trace the post-click conversions. All tracking links contain the affiliate's number, which allows the platform to attribute sales to the leverage that contributed to them. Tracking links are used for CPA (% commission on sale) or CPL (cost per lead) remuneration.",
// 			"Editor": {
// 			  "Type": "Group"
// 			},
// 			"IsActiveProperty": {
// 			  "Name": "ISACTIVE",
// 			  "Value": false
// 			},
// 			"Content": [
// 			  {
// 				"Name": "CLICK_CTA_URL",
// 				"Value": "",
// 				"FriendlyName": "After clicking on call to action",
// 				"Editor": {
// 				  "Type": "Text"
// 				}
// 			  }
// 			]
// 		  }
// 		],
// 		"WysiwygDesktop": {
// 		  "Template": "<style type=\"text/css\">\n\thtml{\n\t\theight: 100%;\n\t}\n\tbody{\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tposition: relative;\n\t}\n\tbody > .desktop{\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 20px;\n\t\tright: 20px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\tbody > .mobile{\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbackground: #fff;\n\t}\n\tbody > .desktop .by_HB_G_0001{\n\t\tflex: 1 1 auto;\n\t}\n\t@media (min-width: 769px){\n\t\t.by_HB_G_0001{\n\t\t\tposition: relative !important;\n\t\t}\n\t}\n</style>\n<style type=\"text/css\">{{Css}}</style>\n<style type=\"text/css\">\n\t@media (min-width: 769px){\n\t\t.by_HB_G_0001,\n\t\t.by_HB_G_0001_pusher{\n\t\t\tmin-height: {{CONTAINER.HEIGHT}}px;\n\t\t}\n\t}\n\t@media (max-width: 768px){\n\t\t.by_HB_G_0001,\n\t\t.by_HB_G_0001_pusher{\n\t\t\tmin-height: {{CONTAINER.HEIGHT_MOB}}px;\n\t\t}\n\t}\n\t.by_HB_G_0001{\n\t\tbackground: {{CONTAINER.BG_COLOR}};\n\t}\n\t.by_HB_G_0001 .by_code{\n\t\tfont-size: {{CODE.FONT_SIZE}}px;\n\t\tborder-radius: {{CODE.BORDER_RADIUS}}px;\n\t\tbackground-color: {{CODE.BG_COLOR}};\n\t\tcolor: {{CODE.TXT_COLOR}};\n\t\tborder-width: {{CODE.BORDER_WIDTH}}px;\n\t}\n\t.by_HB_G_0001 .by_tooltip{\n\t\tbackground: {{CODE.TOOLTIP_BG_COLOR}};\n\t\tcolor: {{CODE.TOOLTIP_TXT_COLOR}};\n\t}\n\t.by_HB_G_0001 .by_cta.by_desktop{\n\t\tfont-size: {{CTA.FONT_SIZE}}px;\n\t}\n\t.by_HB_G_0001 .by_cta.by_mobile{\n\t\tfont-size: {{CTA.FONT_SIZE_MOB}}px;\n\t}\n\t.by_HB_G_0001 .by_cta{\n\t\tborder-radius: {{CTA.BORDER_RADIUS}}px;\n\t\tbackground-color: {{CTA.BG_COLOR}};\n\t\tcolor: {{CTA.TXT_COLOR}};\n\t\tborder-width: {{CTA.BORDER_WIDTH}}px;\n\t}\n\t{% if CTA.IS_UNDERLINE %}\n\t\t.by_HB_G_0001 .by_cta{\n\t\t\ttext-decoration: underline;\n\t\t}\n\t{% endif %}\n\t{% if CTA.IS_BOLD %}\n\t\t.by_HB_G_0001 .by_cta{\n\t\t\tfont-weight: 700;\n\t\t}\n\t{% endif %}\n\n\t@media (min-width: 769px){\n\t\t.by_HB_G_0001 .by_countdown_value{\n\t\t\tfont-size: {{COUNTDOWN.VALUE_TEXT_SIZE}}px;\n\t\t}\n\t\t.by_HB_G_0001 .by_countdown,\n\t\t.by_HB_G_0001 .by_countdown_label{\n\t\t\tfont-size: {{COUNTDOWN.UNIT_TEXT_SIZE}}px;\n\t\t}\n\t}\n\t@media (max-width: 768px){\n\t\t.by_HB_G_0001 .by_countdown_value{\n\t\t\tfont-size: {{COUNTDOWN.VALUE_TEXT_SIZE_MOB}}px;\n\t\t}\n\t\t.by_HB_G_0001 .by_countdown,\n\t\t.by_HB_G_0001 .by_countdown_label{\n\t\t\tfont-size: {{COUNTDOWN.UNIT_TEXT_SIZE_MOB}}px;\n\t\t}\n\t}\n\n\t.by_HB_G_0001 .by_close{\n\t\tcolor: {{CLOSE.COLOR}};\n\t}\n\t.by_HB_G_0001 .by_close_inner::before{\n\t\twidth: {{CLOSE.THICKNESS}}px;\n\t\theight: {{CLOSE.WIDTH}}px;\n\t}\n\t.by_HB_G_0001 .by_close_inner::after{\n\t\twidth: {{CLOSE.WIDTH}}px;\n\t\theight: {{CLOSE.THICKNESS}}px;\n\t}\n\t{% if CLOSE.ALIGN == \"top\" %}\n\t\t.by_HB_G_0001 .by_close{\n\t\t\talign-items: flex-start;\n\t\t}\n\t{% endif %}\n</style>\n\n<div class=\"by_HB_G_0001\n\tby_position_{{CONTAINER.POSITION}}\n\tby_position_mob_{{CONTAINER.POSITION_MOB}}\n\tby_layout_mob_{{CONTAINER.LAYOUT_MOB}}\">\n\t<div class=\"by_content\">\n\t\t<div class=\"by_col_main\">\n\t\t\t<div class=\"by_col_text by_text by_desktop\">{{BODY.TEXT1}}</div>\n\t\t\t<div class=\"by_col_text by_text by_mobile\">{{BODY.TEXT1_MOB}}</div>\n\t\t\t<div class=\"by_col_countdown\">\n\t\t\t\t<div class=\"by_countdown by-js-countdown\">\n\t\t\t\t\t{% if COUNTDOWN.HIDE_SECONDS != true or COUNTDOWN.DATE_DAYS != 0 %}\n\t\t\t\t\t<div class=\"by_countdown_item by-js-day\">\n\t\t\t\t\t\t<span class=\"by_countdown_value by-js-val\">{{COUNTDOWN.DATE_DAYS}}</span>&nbsp;<span class=\"by_countdown_label\">{{COUNTDOWN.LABEL_DAY}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t{% endif %}\n\t\t\t\t\t<div class=\"by_countdown_item by-js-hour\">\n\t\t\t\t\t\t<span class=\"by_countdown_value by-js-val\">{{COUNTDOWN.DATE_HOURS}}</span>&nbsp;<span class=\"by_countdown_label\">{{COUNTDOWN.LABEL_HOUR}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"by_countdown_item by-js-min\">\n\t\t\t\t\t\t<span class=\"by_countdown_value by-js-val\">{{COUNTDOWN.DATE_MINUTES}}</span>&nbsp;<span class=\"by_countdown_label\">{{COUNTDOWN.LABEL_MIN}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t{% if COUNTDOWN.HIDE_SECONDS != true or COUNTDOWN.DATE_DAYS == 0 %}\n\t\t\t\t\t\t<div class=\"by_countdown_item by-js-sec\">\n\t\t\t\t\t\t\t<span class=\"by_countdown_value by-js-val\">{{COUNTDOWN.DATE_SECONDS}}</span>&nbsp;<span class=\"by_countdown_label\">{{COUNTDOWN.LABEL_SEC}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t{% endif %}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"by_col_text by_text by_desktop\">{{BODY.TEXT2}}</div>\n\t\t\t<div class=\"by_col_text by_text by_mobile\">{{BODY.TEXT2_MOB}}</div>\n\t\t</div>\n\t\t{% if CTA.ISACTIVE %}\n\t\t\t<div class=\"by_col_cta\">\n\t\t\t\t<a class=\"by_cta by_desktop\">{{CTA.TEXT}}</a>\n\t\t\t\t<a class=\"by_cta by_mobile\">{{CTA.TEXT_MOB}}</a>\n\t\t\t</div>\n\t\t{% endif %}\n\t</div>\n\n\t{% if CLOSE.ISACTIVE %}\n\t<div class=\"by_close\">\n\t\t<span class=\"by_close_inner by-js-close\"></span>\n\t</div>\n\t{% endif %}\n</div>\n",
// 		  "WysiwygMobileTemplateType": 2
// 		},
// 		"WysiwygMobile": {
// 		  "Template": "<style type=\"text/css\">\n\thtml{\n\t\theight: 100%;\n\t}\n\tbody{\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tposition: relative;\n\t}\n\tbody > .desktop{\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 20px;\n\t\tright: 20px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\tbody > .mobile{\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbackground: #fff;\n\t}\n\tbody > .desktop .by_HB_G_0001{\n\t\tflex: 1 1 auto;\n\t}\n\t@media (min-width: 769px){\n\t\t.by_HB_G_0001{\n\t\t\tposition: relative !important;\n\t\t}\n\t}\n</style>\n<style type=\"text/css\">{{Css}}</style>\n<style type=\"text/css\">\n\t@media (min-width: 769px){\n\t\t.by_HB_G_0001,\n\t\t.by_HB_G_0001_pusher{\n\t\t\tmin-height: {{CONTAINER.HEIGHT}}px;\n\t\t}\n\t}\n\t@media (max-width: 768px){\n\t\t.by_HB_G_0001,\n\t\t.by_HB_G_0001_pusher{\n\t\t\tmin-height: {{CONTAINER.HEIGHT_MOB}}px;\n\t\t}\n\t}\n\t.by_HB_G_0001{\n\t\tbackground: {{CONTAINER.BG_COLOR}};\n\t}\n\t.by_HB_G_0001 .by_code{\n\t\tfont-size: {{CODE.FONT_SIZE}}px;\n\t\tborder-radius: {{CODE.BORDER_RADIUS}}px;\n\t\tbackground-color: {{CODE.BG_COLOR}};\n\t\tcolor: {{CODE.TXT_COLOR}};\n\t\tborder-width: {{CODE.BORDER_WIDTH}}px;\n\t}\n\t.by_HB_G_0001 .by_tooltip{\n\t\tbackground: {{CODE.TOOLTIP_BG_COLOR}};\n\t\tcolor: {{CODE.TOOLTIP_TXT_COLOR}};\n\t}\n\t.by_HB_G_0001 .by_cta.by_desktop{\n\t\tfont-size: {{CTA.FONT_SIZE}}px;\n\t}\n\t.by_HB_G_0001 .by_cta.by_mobile{\n\t\tfont-size: {{CTA.FONT_SIZE_MOB}}px;\n\t}\n\t.by_HB_G_0001 .by_cta{\n\t\tborder-radius: {{CTA.BORDER_RADIUS}}px;\n\t\tbackground-color: {{CTA.BG_COLOR}};\n\t\tcolor: {{CTA.TXT_COLOR}};\n\t\tborder-width: {{CTA.BORDER_WIDTH}}px;\n\t}\n\t{% if CTA.IS_UNDERLINE %}\n\t\t.by_HB_G_0001 .by_cta{\n\t\t\ttext-decoration: underline;\n\t\t}\n\t{% endif %}\n\t{% if CTA.IS_BOLD %}\n\t\t.by_HB_G_0001 .by_cta{\n\t\t\tfont-weight: 700;\n\t\t}\n\t{% endif %}\n\n\t@media (min-width: 769px){\n\t\t.by_HB_G_0001 .by_countdown_value{\n\t\t\tfont-size: {{COUNTDOWN.VALUE_TEXT_SIZE}}px;\n\t\t}\n\t\t.by_HB_G_0001 .by_countdown,\n\t\t.by_HB_G_0001 .by_countdown_label{\n\t\t\tfont-size: {{COUNTDOWN.UNIT_TEXT_SIZE}}px;\n\t\t}\n\t}\n\t@media (max-width: 768px){\n\t\t.by_HB_G_0001 .by_countdown_value{\n\t\t\tfont-size: {{COUNTDOWN.VALUE_TEXT_SIZE_MOB}}px;\n\t\t}\n\t\t.by_HB_G_0001 .by_countdown,\n\t\t.by_HB_G_0001 .by_countdown_label{\n\t\t\tfont-size: {{COUNTDOWN.UNIT_TEXT_SIZE_MOB}}px;\n\t\t}\n\t}\n\n\t.by_HB_G_0001 .by_close{\n\t\tcolor: {{CLOSE.COLOR}};\n\t}\n\t.by_HB_G_0001 .by_close_inner::before{\n\t\twidth: {{CLOSE.THICKNESS}}px;\n\t\theight: {{CLOSE.WIDTH}}px;\n\t}\n\t.by_HB_G_0001 .by_close_inner::after{\n\t\twidth: {{CLOSE.WIDTH}}px;\n\t\theight: {{CLOSE.THICKNESS}}px;\n\t}\n\t{% if CLOSE.ALIGN == \"top\" %}\n\t\t.by_HB_G_0001 .by_close{\n\t\t\talign-items: flex-start;\n\t\t}\n\t{% endif %}\n</style>\n\n<div class=\"by_HB_G_0001\n\tby_position_{{CONTAINER.POSITION}}\n\tby_position_mob_{{CONTAINER.POSITION_MOB}}\n\tby_layout_mob_{{CONTAINER.LAYOUT_MOB}}\">\n\t<div class=\"by_content\">\n\t\t<div class=\"by_col_main\">\n\t\t\t<div class=\"by_col_text by_text by_desktop\">{{BODY.TEXT1}}</div>\n\t\t\t<div class=\"by_col_text by_text by_mobile\">{{BODY.TEXT1_MOB}}</div>\n\t\t\t<div class=\"by_col_countdown\">\n\t\t\t\t<div class=\"by_countdown by-js-countdown\">\n\t\t\t\t\t{% if COUNTDOWN.HIDE_SECONDS != true or COUNTDOWN.DATE_DAYS != 0 %}\n\t\t\t\t\t<div class=\"by_countdown_item by-js-day\">\n\t\t\t\t\t\t<span class=\"by_countdown_value by-js-val\">{{COUNTDOWN.DATE_DAYS}}</span>&nbsp;<span class=\"by_countdown_label\">{{COUNTDOWN.LABEL_DAY}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t{% endif %}\n\t\t\t\t\t<div class=\"by_countdown_item by-js-hour\">\n\t\t\t\t\t\t<span class=\"by_countdown_value by-js-val\">{{COUNTDOWN.DATE_HOURS}}</span>&nbsp;<span class=\"by_countdown_label\">{{COUNTDOWN.LABEL_HOUR}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"by_countdown_item by-js-min\">\n\t\t\t\t\t\t<span class=\"by_countdown_value by-js-val\">{{COUNTDOWN.DATE_MINUTES}}</span>&nbsp;<span class=\"by_countdown_label\">{{COUNTDOWN.LABEL_MIN}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t{% if COUNTDOWN.HIDE_SECONDS != true or COUNTDOWN.DATE_DAYS == 0 %}\n\t\t\t\t\t\t<div class=\"by_countdown_item by-js-sec\">\n\t\t\t\t\t\t\t<span class=\"by_countdown_value by-js-val\">{{COUNTDOWN.DATE_SECONDS}}</span>&nbsp;<span class=\"by_countdown_label\">{{COUNTDOWN.LABEL_SEC}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t{% endif %}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"by_col_text by_text by_desktop\">{{BODY.TEXT2}}</div>\n\t\t\t<div class=\"by_col_text by_text by_mobile\">{{BODY.TEXT2_MOB}}</div>\n\t\t</div>\n\t\t{% if CTA.ISACTIVE %}\n\t\t\t<div class=\"by_col_cta\">\n\t\t\t\t<a class=\"by_cta by_desktop\">{{CTA.TEXT}}</a>\n\t\t\t\t<a class=\"by_cta by_mobile\">{{CTA.TEXT_MOB}}</a>\n\t\t\t</div>\n\t\t{% endif %}\n\t</div>\n\n\t{% if CLOSE.ISACTIVE %}\n\t<div class=\"by_close\">\n\t\t<span class=\"by_close_inner by-js-close\"></span>\n\t</div>\n\t{% endif %}\n</div>\n",
// 		  "WysiwygMobileTemplateType": 2
// 		}
// 	  }
// 	],
// 	"Identifier": "stress_headerbar_countdown",
// 	"Triggers": []
//   };